import React from 'react';
import './AddPaymentPorterWizard.css';

// THE REVIEW STEP'S LIST — label / value rows in one panel, shared by the product create wizards (Universal API
// access and payload, MCP as a Service). `rows` is [[label, value], …]; an empty value shows as "—" so a row that
// has nothing to say still reads as deliberate rather than as something that failed to load.
const WizardReview = ({ rows, style }) => (
    <div className="ppw-review" style={style}>
        {rows.map(([label, value]) => (
            <div key={label} className="ppw-review-row">
                <span className="ppw-review-label">{label}</span>
                <span className="ppw-review-value">{value === undefined || value === null || value === '' ? '—' : value}</span>
            </div>
        ))}
    </div>
);

export default WizardReview;
